<template>
  <div class="zh-viewer">
    <article class="zh-card">
      <header class="zh-head">
        <div class="zh-brand">{{ brandLabel }}</div>
        <h1 class="zh-title">{{ item.title }}</h1>
        <div class="zh-author">
          <div class="zh-avatar">
            <img v-if="item.authorAvatar" :src="item.authorAvatar" alt="" referrerpolicy="no-referrer" />
            <span v-else>{{ (item.authorName || '?')[0] }}</span>
          </div>
          <div>
            <div class="zh-author-name">{{ item.authorName || '作者' }}</div>
            <div class="zh-meta">
              <span v-if="item.publishedAt">{{ item.publishedAt }}</span>
              <span v-if="item.views">阅读 {{ formatCount(item.views) }}</span>
            </div>
          </div>
        </div>
      </header>

      <div v-if="item.coverUrl && !item.contentHtml" class="zh-cover-wrap">
        <img class="zh-cover" :src="item.coverUrl" alt="" referrerpolicy="no-referrer" />
      </div>

      <div
        v-if="item.contentHtml"
        class="zh-html"
        v-html="safeHtml"
      />
      <div v-else class="zh-text">{{ item.content || '暂无正文摘要' }}</div>

      <footer class="zh-bar">
        <span class="zh-vote">▲ 赞同 {{ formatCount(item.likes) }}</span>
        <span>💬 评论 {{ formatCount(item.comments) }}</span>
        <span v-if="item.hearts">♡ 喜欢 {{ formatCount(item.hearts) }}</span>
        <span v-if="item.collects">☆ 收藏 {{ formatCount(item.collects) }}</span>
      </footer>
    </article>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatCount } from './normalizeContent'

const props = defineProps({
  item: { type: Object, required: true },
})

const brandLabel = computed(() => {
  const t = (props.item?.noteType || props.item?.note_type || '').toLowerCase()
  return t === 'answer' ? '知乎 · 回答' : '知乎 · 专栏'
})

/** 轻量清洗：去掉 script，保留常见富文本标签 */
const safeHtml = computed(() => {
  const html = props.item?.contentHtml || ''
  if (!html) return ''
  return html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*(['"]).*?\1/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
})
</script>

<style scoped>
.zh-viewer {
  display: flex;
  justify-content: center;
  padding: 4px 0;
  background: linear-gradient(180deg, #eef4ff 0%, #f6f7f9 35%, #f6f7f9 100%);
}
.zh-card {
  width: min(680px, 100%);
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e7ebf2;
  box-shadow: 0 8px 28px rgba(34, 52, 84, 0.06);
  overflow: hidden;
}
.zh-head { padding: 22px 28px 8px; }
.zh-brand {
  color: #056de8;
  font-size: 12px;
  font-weight: 650;
  margin-bottom: 10px;
  letter-spacing: 0.02em;
}
.zh-title {
  margin: 0 0 16px;
  font-size: 24px;
  line-height: 1.35;
  color: #121212;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.zh-author {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.zh-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  overflow: hidden;
  background: #dce8ff;
  color: #056de8;
  display: grid;
  place-items: center;
  font-weight: 700;
}
.zh-avatar img { width: 100%; height: 100%; object-fit: cover; }
.zh-author-name { font-size: 14px; font-weight: 600; color: #1a1a1a; }
.zh-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #8590a6;
  margin-top: 2px;
}
.zh-cover-wrap { padding: 8px 28px 0; }
.zh-cover {
  width: 100%;
  max-height: 280px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}
.zh-html,
.zh-text {
  padding: 16px 28px 8px;
  font-size: 15px;
  line-height: 1.85;
  color: #1a1a1a;
}
.zh-text { white-space: pre-wrap; }
.zh-html :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 8px 0;
}
.zh-html :deep(p) { margin: 0 0 1em; }
.zh-html :deep(h2),
.zh-html :deep(h3) {
  margin: 1.2em 0 0.6em;
  line-height: 1.4;
}
.zh-html :deep(blockquote) {
  margin: 12px 0;
  padding: 8px 14px;
  border-left: 3px solid #056de8;
  background: #f6f8fb;
  color: #444;
}
.zh-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 14px 28px 20px;
  border-top: 1px solid #f0f2f5;
  color: #646464;
  font-size: 13px;
}
.zh-vote {
  color: #056de8;
  font-weight: 600;
}
</style>
